import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { CheckCircle } from "lucide-react";
import { useToastContext } from "../../context/ToastContext";

const SlackSuccess: React.FC = () => {
  const { showToast } = useToastContext();
  const navigate = useNavigate();
  const [status, setStatus] = useState<"loading" | "success">("loading");

  useEffect(() => {
    showToast("success", "Slack successfully connected!");
    setStatus("success");
  }, [showToast]);

  return (
    <div className="flex flex-col justify-center items-center h-screen bg-background-default dark:bg-background-dark px-6 text-center relative -mt-16">
      {status === "loading" && (
        <div className="flex flex-col items-center text-text-primary dark:text-text-primaryDark">
          <h2 className="text-2xl font-semibold">
            Finalizing Slack Connection...
          </h2>
          <p className="text-sm text-text-secondary dark:text-text-secondaryDark mt-2">
            Almost there! This process takes just a moment.
          </p>
        </div>
      )}

      {status === "success" && (
        <div className="flex flex-col items-center text-text-primary dark:text-text-primaryDark">
          <CheckCircle className="w-16 h-16 text-green-dark mb-6" />
          <h2 className="text-2xl font-semibold">
            Slack Successfully Connected
          </h2>
          <p className="text-sm text-text-secondary dark:text-text-secondaryDark mt-4">
            Your organization is now linked with Slack.
          </p>
          <button
            onClick={() => navigate("/integrations")}
            className="mt-6 px-6 py-3 border-2 border-green-dark text-green-dark rounded-lg font-bold text-sm hover:bg-green-dark hover:text-white transition"
          >
            Integrations
          </button>
        </div>
      )}
    </div>
  );
};

export default SlackSuccess;
